import React from 'react';
import { Modal } from 'react-bootstrap';
import ModalHeader from 'components/Modal/ModalHeader';
import { connect } from 'react-redux';
import { Field, reduxForm, isPristine, getFormInitialValues } from 'redux-form';
import { cancelAssignToIngredient } from 'actions/ingredients/category';
import Ingredients from './Ingredients';
import style from './style.css';
import Search from './Search';

class AssignToIngredientModal extends React.Component {
  render() {
    const { showAssignToIngredientModal, isPristineForm, IngForm } = this.props;

    return (
      <Modal
        show={showAssignToIngredientModal}
        onHide={this._onHide}
        className={`${style.modalingredient}`}
      >
        <ModalHeader title="Assign To Ingredient" />
        <form onSubmit={this.props.handleSubmit}>
          <Field component="input" type="hidden" name="id" />
          <Field component="input" type="hidden" name="ingredientIds" />
          <Modal.Body>
            <Search />
            <Ingredients />
          </Modal.Body>
          <Modal.Footer>
            <span className="pull-left">
              <button className="btn btn-default" onClick={this._onHide}>
                Cancel
              </button>
            </span>
            <span className="pull-right">
              <button
                className="btn btn-primary"
                disabled={isPristineForm && !(IngForm.ingredientIds.length > 0)}
              >
                Move Selected Ingredients
              </button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  _onHide = event => {
    event.preventDefault();
    event.stopPropagation();
    const { dispatch } = this.props;
    dispatch(cancelAssignToIngredient());
  };
}

function mapStateToProps(state) {
  const { showAssignToIngredientModal } = state.ingredients.category;
  return {
    showAssignToIngredientModal,
    isPristineForm: isPristine('assignToIngredient')(state),
    IngForm: getFormInitialValues('assignToIngredient')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const mapForm = {
  form: 'assignToIngredient',
};
export default reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AssignToIngredientModal)
);
